export const giftsOf = (exhibition) => exhibition?.gifts || { enabled: false, discount: false, instore: false, instore_name: {} };

export function discountOf(exhibition) {
  return exhibition?.gifts?.discount_percent || 25;
}

export function giftName(exhibition, lang, t) {
  const names = exhibition?.gifts?.instore_name || {};
  return names[lang] || names.en || t("gift_poster_title");
}
